const config = {
    toolbar: ["bold", "italic"],
    removePlugins: ["Autoformat"]
};

export default config;
